import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialSaleOperationPageState,
  SaleOperationItemData,
  SaleOperationListResponse,
  SaleOperationListStateType,
} from "../core/_model.sale-opeation";

export type ActionedSaleOperation = {
  data: SaleOperationItemData | null;
  action: ActionsKey;
};

type SaleOperationDataType = {
  saleOperationList: any;
  detail: SaleOperationItemData | null;
  actioned: ActionedSaleOperation | null;
  totalItems: number;
  setDetail: (detail: SaleOperationItemData | null) => void;
  setSaleOperationList: (roles: SaleOperationListResponse | null) => void;
  setActioned: (act: ActionedSaleOperation | null) => void;
};

export const useSaleOperationStore = create<SaleOperationDataType>((set) => ({
  saleOperationList: [],
  detail: null,
  actioned: null,
  totalItems: 0,
  setDetail: (detail) => set((state) => ({ detail })),
  setSaleOperationList: (saleData) =>
    set((state) => ({
      saleOperationList: saleData?.member,
      totalItems: saleData?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));

export const useSaleOperationListState = create<SaleOperationListStateType>(
  (set) => ({
    pageState: initialSaleOperationPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
  })
);
